import React from 'react';
import Field from '../../../../../../../../../../../../BaseComponents/Forms/EDField';
import EDRadioGroup from '../../../../../../../../../../../../BaseComponents/RadioGroup/EDRadioGroup';
import { BudgetTypes } from '../EkonomiskAnalysEditColumnForm';
import { Theme } from '@mui/material/styles';

import { withStyles } from 'tss-react/mui';

const styles = (theme: Theme) => ({
  radioGroup: { flexDirection: 'row' },
});

interface IProps {
  classes?: any;
}

class EkonomiskAnalysEditColumnBudgetRadioGroup extends React.Component<IProps> {
  render() {
    return (
      <Field name={'budgetType'}>
        {({ value, onChange, form }) => (
          <EDRadioGroup
            label={'Budget'}
            value={value}
            onChange={value => {
              // Reset budget when changing budget type
              form.setFieldValue('budget', '');
              onChange(value);
            }}
            radioDefs={[
              { label: 'Alla', value: BudgetTypes.all },
              { label: 'Kategori', value: BudgetTypes.category },
              { label: 'Specifik Budget', value: BudgetTypes.specific },
            ]}
            classes={{ group: this.props.classes.radioGroup }}
          />
        )}
      </Field>
    );
  }
}

export default withStyles(EkonomiskAnalysEditColumnBudgetRadioGroup, styles);
